// extracted by mini-css-extract-plugin
module.exports = {"activeOption":"fP","option":"fQ","phone":"fR","value":"fS","text":"fT","label":"fU","list":"fV","centerMenu":"fW","active":"fX"};